/**
 * Dodatkowe tłumaczenia dla Django JavaScript.
 * Ten plik zawiera ręcznie dodane tłumaczenia używające funkcji gettext.
 * Django makemessages automatycznie wykryje te stringi.
 */

// Funkcja gettext powinna być dostępna globalnie przez django.gettext
// lub zaimportowana z odpowiedniego modułu

// Dodatkowe tłumaczenia

// "Search" -> "Search"
gettext("Search");

// "Date Range" -> "Date Range"
gettext("Date Range");

// "all" -> "all"
gettext("all");

// "ready to send" -> "ready to send"
gettext("ready to send");

// "shipment sent" -> "shipment sent"
gettext("shipment sent");

// "created" -> "created"
gettext("created");

// "reserved" -> "reserved"
gettext("reserved");

// "unit sent" -> "unit sent"
gettext("unit sent");

// "active" -> "active"
gettext("active");

// "archived" -> "archived"
gettext("archived");

// "EDI recipient" -> "EDI recipient"
gettext("EDI recipient");

// "EDI success" -> "EDI delivered"
gettext("EDI success");

// "EDI error" -> "EDI error"
gettext("EDI error");
